import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { useEffect } from "react";

export const LanguageToggle = () => {
  const { i18n, t } = useTranslation();

  // Initialize language to Portuguese
  useEffect(() => {
    console.log('Setting default language to Portuguese');
    i18n.changeLanguage('pt');
    localStorage.setItem('preferredLanguage', 'pt');
  }, []); // Empty dependency array to run only once

  const toggleLanguage = () => {
    const currentLang = i18n.language;
    const newLang = currentLang === 'pt' ? 'en' : 'pt';
    console.log('Changing language from:', currentLang, 'to:', newLang);
    
    i18n.changeLanguage(newLang).then(() => {
      localStorage.setItem('preferredLanguage', newLang);
      console.log('Language changed successfully to:', newLang);
      console.log('Current i18n language:', i18n.language);
    }).catch(error => {
      console.error('Error changing language:', error);
    });
  };

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={toggleLanguage}
      className="fixed top-4 right-4 w-9 h-9 sm:w-auto sm:h-10 sm:px-4"
      title={i18n.language === 'pt' ? 'Switch to English' : 'Mudar para Português'}
    >
      <Globe className="h-4 w-4 sm:mr-2" />
      <span className="hidden sm:inline">
        {i18n.language === 'pt' ? 'English' : 'Português'}
      </span>
    </Button>
  );
};